import { GetQueryString } from './util'
import { getWXCode } from './getWXCode'
import { getToken } from "./getToken"

const wxcode = GetQueryString('code')


export const userAuth = () => {
    return new Promise( (resolve, reject) => {
        if (process.env.NODE_ENV === 'development') {
            resolve()
            return
        }
        if (!localStorage.token) {  // 没有token
            if (!wxcode) {  // 没有wxcode
                getWXCode()
                reject()
            } else { // 有wxcode
                
                history.replaceState(null, null, location.href.replace(/&(?:code|state)=.*?(?=[&#\/])|[&\?]?(?:code|state)=[^&#\/]*?$|(?:code|state)=.*?(?=[&#\/])&?/g, '').replace('?#', '#'), '')

                getToken(wxcode, 2).then(() => {
                    resolve()
                })
            }
        } else {
            console.log('有token', 'Wechat')
            resolve()
        }
    })
}

export const appAuth = (token, tokenType) => {
    return new Promise((resolve, reject) => {
        if (process.env.NODE_ENV === 'development') {
            resolve()
            return
        }
        if(localStorage.token) {    //如果有token就不用获取了
            resolve()
        }else{ //没有token重新获取token
            getToken(token, tokenType).then(() => {
                resolve()
            })
        }
    })
}

export const isWeixinCient = () => {
    return navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger"
}



// WEBPACK FOOTER //
// ./src/utils/userAuth.js